<template>
  <div class="create d-flex flex-column" :class="!isCustomize ? '' : 'h-100 overflow-auto'">
    
    <!-- Main Header -->
    <Header></Header>
    
    <!-- Main Form Fields -->
    <form
      v-if="!isCustomize"
      class="my-4 text-left"
      @submit.prevent="onSubmit"
      :data-synerise="this.nodeEnv != 'development' ? 'contact' : false"
    >
      <div class="form-row">
        <div class="col-md-12">
          <label>Full Name</label>
        </div>

        <!-- First Name -->
        <div class="col-md-6">
          <input
            type="text"
            class="form-control"
            :data-synerise="this.nodeEnv != 'development' ? 'firstname' : false"
            placeholder="First name"
            v-model="user.firstName"
            :class="{ 'is-invalid': attemptSubmit && missingFName }"
          >
          <div class="invalid-feedback">
            This field is required
          </div>
        </div>

        <!-- Last Name -->
        <div class="col-md-6">
          <input
            type="text"
            class="form-control mt-md-0 mt-3"
            placeholder="Last name"
            :data-synerise="this.nodeEnv != 'development' ? 'lastname' : false"
            v-model="user.lastName"
            :class="{ 'is-invalid': attemptSubmit && missingLName }"
          >
          <div class="invalid-feedback">
            This field is required
          </div>
        </div>
      </div>

      <div class="form-row mt-4">
        <div class="col-md-12">
          <label>Personal Primary Information</label>
        </div>

        <!-- Primary Email -->
        <div class="col-md-6">
          <input
            type="email"
            class="form-control"
            placeholder="Primary Email Address"
            v-model="user.secondary_email"
            :class="{ 'is-invalid': attemptSubmit && !validBackupEmail && user.secondary_email != '' }"
          >

          <!-- If email is invalid -->
          <div class="invalid-feedback">
            Please enter a valid email.
          </div>
        </div>

        <!-- Primary Mobile -->
        <div class="col-md-6">
          <vue-tel-input 
            v-model.lazy="user.phoneNum"
            placeholder="Primary Phone Number"
            class="mt-md-0 mt-3"
            :enabledCountryCode="true"
            :class="{ 'is-invalid': attemptSubmit && !validPhoneNum && user.phoneNum != '' }"
            @input="checkPhoneNum"></vue-tel-input>

          <!-- If email is invalid -->
          <div class="invalid-feedback">
            Please enter a valid work number.
          </div>
        </div>
      </div>

      <div class="form-row mt-4">
        <div class="col-12">
          <label class="mb-0 d-block">Company Details</label>
          <div class="form-check">
            <input type="checkbox" class="form-check-input" @input="sameDetails" v-model="sameAsPrimary" id="sameDetails">
            <label class="form-check-label mr-1 mb-1" for="sameDetails">
              <small>Same as Primary</small>
            </label>
          </div>
        </div>

        <!-- Company Name -->
        <div class="col-md-6">
          <input
            type="text"
            class="form-control"
            :data-synerise="this.nodeEnv != 'development' ? 'company' : false"
            placeholder="Company name"
            v-model="user.companyName"
          >
        </div>

        <!-- Job Title -->
        <div class="col-md-6">
          <input
            type="text"
            class="form-control mt-md-0 mt-3"
            :data-synerise="this.nodeEnv != 'development' ? 'jobtitle' : false"
            placeholder="Job Title"
            v-model="user.jobTitle"
          >
        </div>

        <!-- Email Address -->
        <div class="col-md-12">
          <input
            type="email"
            class="form-control mt-3"
            placeholder="Email Address"
            :data-synerise="this.nodeEnv != 'development' ? 'email' : false"
            v-model="user.email"
            :class="{ 'is-invalid': attemptSubmit && missingLName || attemptSubmit && !validEmail || attemptSubmit && emailError != '' }"
          >

          <!-- If email is already registered -->
          <div
            class="invalid-feedback"
            v-if="emailError != ''"
          >
            A user with that email has already registered. Please use a different email. Please click <router-link to="/email">here</router-link> to generate edit link
          </div>

          <!-- If email is invalid -->
          <div
            class="invalid-feedback"
            v-else
          >
            Please enter a valid email or in case you have already registered please click <router-link to="/email">here</router-link> to generate the edit link.
          </div>
        </div>

        <!-- Work Number 1 -->
        <div class="col-md-6">
          <vue-tel-input 
          v-model.lazy="user.workNum" 
          class="mt-3"
          placeholder="Work Number"
          :enabledCountryCode="true"
          :class="{ 'is-invalid': attemptSubmit && !validNum1 && user.workNum != '' }"
          @input="checkWorkNum1"></vue-tel-input>

          <!-- If email is invalid -->
          <div class="invalid-feedback">
            Please enter a valid work number.
          </div>
        </div>

        <!-- Work Number 2 -->
        <div class="col-md-6">
          <vue-tel-input 
          v-model.lazy="user.workNum2" 
          class="mt-3"
          placeholder="Work Number 2"
          :enabledCountryCode="true"
          :class="{ 'is-invalid': attemptSubmit && !validNum2 && user.workNum2 != '' }"
          @input="checkWorkNum2"></vue-tel-input>

          <!-- If email is invalid -->
          <div class="invalid-feedback">
            Please enter a valid work number.
          </div>
        </div>

        <!-- Website -->
        <div class="col-12">
          <input
            id="website"
            v-on:blur="checkWebsite"
            type="text"
            class="form-control mt-3"
            :data-synerise="this.nodeEnv != 'development' ? 'website' : false"
            placeholder="Website"
            v-model="user.website"
          >
        </div>

        <!-- LinkedIn -->
        <div class="col-12">
          <input
            id="linkedIn"
            v-on:blur="checkLinkedIn"
            type="text"
            class="form-control mt-3"
            :data-synerise="this.nodeEnv != 'development' ? 'linkedin' : false"
            placeholder="LinkedIn URL"
            v-model="user.linkedIn"
            :class="{ 'is-invalid':  attemptSubmit && !validLinkedIn && user.linkedIn != '' }"
          >
          <div class="invalid-feedback">
            Please enter a valid LinkedIn URL (ex. https://www.linkedin.com/in/@username)
          </div>
        </div>

        <!-- Twitter -->
        <div class="col-12">
          <input
            id="twitter"
            v-on:blur="checkTwitter"
            type="text"
            class="form-control mt-3"
            :data-synerise="this.nodeEnv != 'development' ? 'twitter' : false"
            placeholder="Twitter URL"
            v-model="user.twitter"
            :class="{ 'is-invalid':  attemptSubmit && !validTwitter && user.twitter != '' }"
          >
          <div class="invalid-feedback">
            Please enter a valid Twitter URL (ex. https://www.twitter.com/@username)
          </div>
        </div>

        <!-- Privacy Policy -->
        <div class="form-check mt-3 ml-1">
          <input
            type="checkbox"
            v-model="privacyPolicy"
            class="form-check-input"
            id="privacyPolicy"
            :class="{ 'is-invalid': attemptSubmit && !privacyPolicy }"
          >
          <label class="form-check-label mr-2" for="privacyPolicy">
            I agree to the <router-link to="/privacy-policy" class="text-primary">Privacy Policy</router-link></label>
          <div class="invalid-feedback">
            You must agree to our Privacy Policy.
          </div>
        </div>
      </div>

      <!-- Form Submit -->
      <div class="form-row mt-4">
        <div class="col-12">
          <button
            type="submit"
            class="btn btn-outline-success mt-3 mr-2 mb-md-0 mr-md-2"
          >
            <span v-if="!loading">Continue</span>
            <img
              v-else
              src="/assets/loader_white.gif"
              alt="loading"
            >
          </button>
          <button
            type="button"
            class="btn btn-outline-secondary mt-3 mb-md-0"
            @click="clear()"
          >Clear</button>
        </div>
      </div>
    </form>

    <!-- Customize Component -->
    <Customize
      :card="card"
      v-if="card != null && isCustomize"
    ></Customize>

    <!-- Main Footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import axios from "axios"
import { VueTelInput } from 'vue-tel-input'

const Header = () => import("../components/Header")
const Footer = () => import("../components/Footer")
const Customize = () => import("./Customize")

export default {
  data() {
    return {
      user: {
        firstName: "",
        lastName: "",

        companyName: "",
        jobTitle: "",

        phoneNum: "",
        workNum: "",
        workNum2: "",
        email: "",
        secondary_email: '',
        website: "",
        linkedIn: "",
        twitter: ""
      },
      sameAsPrimary: false,
      privacyPolicy: false,
      attemptSubmit: false,
      isCustomize: false,
      card: {},
      loading: false,

      validPhoneNum: false,
      validEmail: false,
      validBackupEmail: false,
      validLinkedIn: false,
      validNum1: false,
      validNum2: false,
      validTwitter: false,
      emailError: "",
      alert: false,
      alertType: ""
    }
  },
  computed: {
    nodeEnv: function() {
      return process.env.NODE_ENV
    },
    authToken: function() {
      return this.$store.state.authToken
    },
    missingFName: function() {
      return this.user.firstName === ""
    },
    missingLName: function() {
      return this.user.lastName === ""
    },
    missingEmail: function() {
      return this.user.email === ""
    }
  },
  components: {
    VueTelInput,
    Customize,
    Header,
    Footer
  },
  methods: {
    clear: function() {
      const userValues = Object.keys(this.user)
      for (const key of userValues) {
        this.user[key] = ''
      }
    },
    checkPhoneNum(formattedNumber, { number, valid, country }) {
      this.validPhoneNum = valid
    },
    checkWorkNum1(formattedNumber, { number, valid, country }) {
      this.validNum1 = valid
    },
    checkWorkNum2(formattedNumber, { number, valid, country }) {
      this.validNum2 = valid
    },
    checkWebsite: function() {
      // Check if Website Field is not blank
      if(this.user.website != "") {
        let newUrl = window.decodeURIComponent(this.user.website)

        // Remove empty spaces
        newUrl = newUrl.trim().replace(/\s/g, "")

        // Transform url to http
        if(!/^(f|ht)tps?:\/\//i.test(newUrl)){
          this.user.website = `http://${newUrl}`
        }
      }
    },
    checkLinkedIn: function() {
      // Check if LinkedIn Field is not blank
      if(this.user.linkedIn != '') {
        let urlLinkedIn = "linkedin.com/in/"

        // Check if field includes the assigned URL
        if(this.user.linkedIn.includes(urlLinkedIn) && !this.validLinkedIn) {
          
          // Transform the field to proper url with https
          let pos = this.user.linkedIn.lastIndexOf(urlLinkedIn)
          this.user.linkedIn = `https://www.linkedin.com/in/${this.user.linkedIn.substring(pos + 16)}`

          // Make the field valid
          this.validLinkedIn = true
        } else {

          // Make the field invalid
          this.validLinkedIn = /(ftp|http|https):\/\/?(?:www\.)?linkedin.com(\w+:{0,1}\w*@)?(\S+)(:([0-9])+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.test(
            this.user.linkedIn
          )
        }
      }
    },
    checkTwitter: function() {
      // Check if Twitter Field is not blank
      if(this.user.twitter != '') {
        let urlTwitter = "twitter.com/"

        // Check if field includes the assigned URL
        if(this.user.twitter.includes(urlTwitter) && !this.validTwitter) {
          
          // Transform the field to proper url with https
          let pos = this.user.twitter.lastIndexOf(urlTwitter)
          this.user.twitter = `https://www.twitter.com/${this.user.twitter.replace('@', '').substring(pos + 12)}`

          // Make the field valid
          this.validTwitter = true
        } else {

          // Make the field invalid
          if(!this.user.twitter.includes(urlTwitter)) {
            this.user.twitter = `https://www.twitter.com/${this.user.twitter}`.replace('@', '')
          }
        }
      }
    },
    checkEmail: async function() {
      const { email } = this.user

      try {
        let res = await axios.get(
          process.env.VUE_APP_API+"/card/check-email.php?email=" + email
        )
        if(res.data == "User doesn't exist") {
          this.createCard()
        } else {
          this.emailError = res.data
          this.loading = false
        }
      } catch (e) {
        this.emailError = e.response.data
        this.loading = false
      }
    },
    validateEmail: function() {
      this.validEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.user.email)
    },
    validateBackupEmail: function() {
      this.validBackupEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.user.secondary_email)
    },
    validations: function() {
      this.validateEmail(this.user.email)
      if (
        this.user.phoneNum != '' && !this.validPhoneNum ||
        this.user.workNum != '' && !this.validNum1 ||
        this.user.workNum2 != '' && !this.validNum2 ||
        this.missingFName ||
        this.missingLName ||
        this.missingEmail ||
        !this.validEmail ||
        !this.privacyPolicy ||
        this.user.linkedIn != "" && !this.validLinkedIn ||
        this.user.twitter != "" && !this.validTwitter ||
        this.user.secondary_email != "" && !this.validBackupEmail
      ) {
        this.loading = false
      } else {
        this.checkEmail()
      }
      if(this.user.linkedIn != "") this.checkLinkedIn()
      if(this.user.twitter != "") this.checkTwitter()
      if(this.user.secondary_email != "") this.validateBackupEmail()
    },
    sameDetails: function() {
      this.user.email =  (this.sameAsPrimary == false) ? this.user.secondary_email : ""
      this.user.workNum =  (this.sameAsPrimary == false) ? this.user.phoneNum : ""
      this.validNum1 = this.validPhoneNum
    },
    onSubmit: function() {
      this.attemptSubmit = true
      this.loading = true
      this.validations()
    },
    createCard: function() {
      axios
        .post(
          process.env.VUE_APP_API+"/card/create.php",
          this.user,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            },
            auth: { 
              username: 'qintro-token',
              password: this.authToken
            }
          }
        )
        .then(response => {
          this.card = response.data
          this.isCustomize = true
          this.loading = false
        }).catch(err => {
          if(err.response.status != 200) {
            this.$store.dispatch('expiredToken')
          } else {
            this.loading = false
          }
        })
    }
  },
  mounted() {
    this.$store.dispatch('checkSetAuthToken')
  }
}
</script>

<style lang="css">
.vue-tel-input {
  border-radius: 0!important;
}
.vti__dropdown {
  background-color: #fff;
  padding-top: 15px!important;
}
.vti__input {
  padding: 20px .75rem .375rem;
}
.vti__dropdown-list {
  color: #000;
}
</style>